export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_NOT_AUTHENTICATED = 'USER_NOT_AUTHENTICATED';

export const FEEDBACK_SHOW_MODAL = 'FEEDBACK_SHOW_MODAL';
export const FEEDBACK_HIDE_MODAL = 'FEEDBACK_HIDE_MODAL';

export const STATUS_MESSAGE_SET = 'STATUS_MESSAGE_SET';
export const STATUS_MESSAGE_CLEAR = 'STATUS_MESSAGE_CLEAR';

export const RTMS_CONNECTED_STATE_SET = 'RTMS_CONNECTED_STATE_SET';
export const RTMS_MESSAGE_RECEIVED = 'RTMS_MESSAGE_RECEIVED';
export const LAYOUT_ENTRY_GUTTER_COMMENTS_SET = 'LAYOUT_ENTRY_GUTTER_COMMENTS_SET';
export const LAYOUT_ENTRY_GUTTER_METRICS_SET = 'LAYOUT_ENTRY_GUTTER_METRICS_SET';